import { defineMessages } from "react-intl";

export const messages: { [key: string]: { id: string, defaultMessage: string } } = defineMessages({
  change: {
    id: "ari.management.updateValue.change",
    defaultMessage: "Change"
  },
  value: {
    id: "ari.management.updateValue.value",
    defaultMessage: "Value"
  },
  rate: {
    id: "ari.management.updateValue.rate",
    defaultMessage: "Rate"
  },
  availability: {
    id: "ari.management.updateValue.availability",
    defaultMessage: "Availability"
  },
  closed: {
    id: "ari.management.updateValue.closed",
    defaultMessage: "Block"
  },
  closeToArrival: {
    id: "ari.management.updateValue.closeToArrival",
    defaultMessage: "CTA"
  },
  closeToDeparture: {
    id: "ari.management.updateValue.closeToDeparture",
    defaultMessage: "CTD"
  },
  minStay: {
    id: "ari.management.updateValue.minStay",
    defaultMessage: "Min stay"
  },
  maxStay: {
    id: "ari.management.updateValue.maxStay",
    defaultMessage: "Max stay"
  },
  minNotice: {
    id: "ari.management.updateValue.minNotice",
    defaultMessage: "Min adv"
  },
  maxNotice: {
    id: "ari.management.updateValue.maxNotice",
    defaultMessage: "Max adv"
  },
  setValue: {
    id: "ari.management.updateValue.setValue",
    defaultMessage: "Set value"
  },
  increaseUnits: {
    id: "ari.management.updateValue.increaseUnits",
    defaultMessage: "Increase units"
  },
  decreaseUnits: {
    id: "ari.management.updateValue.decreaseUnits",
    defaultMessage: "Decrease units"
  },
  introduceValue: {
    id: "ari.management.updateValue.introduceValue",
    defaultMessage: "Introduce value"
  },
  helpText: {
    id: "ari.management.updateValue.helpText",
    defaultMessage: "Check the box to block all lines on the selected date."
  }
});